/*eslint-disable */
export default {
  name: 'assignmentlist',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
